"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useAcceptStrToMap_1 = __importDefault(require("./useAcceptStrToMap"));
var useOnChangeFile = function (setFileName, onChange, accept) {
    var acceptMap = (0, useAcceptStrToMap_1.default)(accept);
    var onChangeFile = (0, react_1.useCallback)(function (event) {
        var _a;
        var eventFile = event;
        var file = event.target.files && event.target.files[0];
        var fileName = '';
        var extension = file ? (_a = file.name.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase() : '';
        if ((accept && acceptMap[".".concat(extension)]) || !accept) {
            fileName = (file === null || file === void 0 ? void 0 : file.name) || '';
        }
        if (accept && !acceptMap[".".concat(extension)]) {
            eventFile.target.value = '';
        }
        setFileName(fileName);
        if (onChange)
            onChange(event);
    }, [
        acceptMap,
        accept,
        onChange,
        setFileName
    ]);
    return onChangeFile;
};
exports.default = useOnChangeFile;
